export const profileData = {
  name: "Araiz Haider",
  title: "Software Engineer",
  pronouns: "He/Him",
  location: "Peterborough, Ontario, Canada",
  email: "iaraizhaider@gmail.com",
  phone: "(437) 559-2979",
  github: "github.com/araizhaider",
  linkedin: "linkedin.com/in/araizhaider",
  about: "Having experience as a Java/J2EE Web Developer with diversified exposure in analysis, design, development and implementation of web-based applications. Always eager to contribute to innovative projects, develop scalable solutions, and continuously learn and grow within a dynamic and fast-paced environment.",
  
  experience: [
    {
      id: 1,
      company: "Kelly",
      position: "Workforce Management Analyst",
      location: "Peterborough, Ontario, Canada (Remote)",
      type: "Permanent Full-time",
      duration: "Mar 2025 - Present",
      period: "10 mos",
      description: [
        "Managing workforce scheduling and resource allocation",
        "Utilizing Deputy and automation tools for efficient workforce management",
        "Implementing data-driven strategies for workforce optimization"
      ],
      skills: ["Deputy", "Schedule Development", "Email Management"]
    },
    {
      id: 2,
      company: "Elysian Software Technologies",
      position: "Senior Software Engineer",
      location: "Pakistan (Hybrid)",
      type: "Permanent Full-time",
      duration: "Oct 2025 - Present",
      period: "3 mos",
      description: [
        "Leading full-stack development projects using Angular and Java/J2EE",
        "Mentoring junior developers and conducting code reviews",
        "Architecting scalable solutions for enterprise applications"
      ],
      skills: ["Angular", "Git", "Spring Boot", "Java"]
    },
    {
      id: 3,
      company: "ResQSoft, Inc.",
      position: "Senior Software Engineer",
      location: "United States (Remote)",
      type: "Contract Full-time",
      duration: "May 2024 - Oct 2025",
      period: "1 yr 6 mos",
      description: [
        "Developed microservices architecture using Spring Boot",
        "Implemented RESTful APIs and integrated with Angular frontend",
        "Optimized application performance and scalability"
      ],
      skills: ["Angular", "Microservices", "Spring Boot", "REST APIs", "Docker"]
    },
    {
      id: 4,
      company: "ResQSoft, Inc.",
      position: "Software Engineer",
      location: "United States (Remote)",
      type: "Contract Part-time",
      duration: "Jan 2023 - Apr 2024",
      period: "1 yr 4 mos",
      description: [
        "Successfully developed and converted legacy struts application to spring boot applications",
        "Handled the security using Spring Security by replacing manual authentication checks",
        "Utilized AWS services alongside Bitbucket to oversee deployment, reducing deployment time by 40%",
        "Architected scalable design patterns such as microservices architecture"
      ],
      skills: ["Git", "NoSQL", "AWS", "Spring Security", "Bitbucket", "Microservices"]
    },
    {
      id: 5,
      company: "ResQSoft, Inc.",
      position: "Junior Software Engineer",
      location: "United States (Remote)",
      type: "Contract Full-time",
      duration: "Jan 2021 - Dec 2022",
      period: "2 yrs",
      description: [
        "Implemented resilient data retrieval from external APIs, enhancing system reliability",
        "Ensured compliance with project standards following SonarQube guidelines",
        "Led enhancement of testing methodologies, taking test coverage from 20% to 85%",
        "Successfully migrated multiple struts projects to Spring Boot and Angular"
      ],
      skills: ["Bitbucket", "Angular", "JUnit", "Spring Boot", "SonarQube"]
    },
    {
      id: 6,
      company: "Trent University",
      position: "Graduate Teaching Assistant",
      location: "Peterborough, Ontario, Canada (On-site)",
      type: "Contract Part-time",
      duration: "Sep 2023 - Apr 2024",
      period: "8 mos",
      description: [
        "Assisted in teaching Big Data Analytics courses",
        "Provided mentorship and guidance to undergraduate students",
        "Conducted lab sessions and graded assignments"
      ],
      skills: ["Written Communication", "Student Engagement", "Teaching"]
    },
    {
      id: 7,
      company: "Elysian Software Technologies",
      position: "Software Engineer",
      location: "Pakistan",
      type: "Permanent Full-time",
      duration: "Dec 2019 - Jan 2021",
      period: "1 yr 2 mos",
      description: [
        "Developed and maintained Java/J2EE web applications",
        "Collaborated with cross-functional teams to deliver software solutions",
        "Implemented best practices for code quality and performance"
      ],
      skills: ["Java", "J2EE", "Spring Framework", "MySQL"]
    }
  ],
  
  education: [
    {
      id: 1,
      institution: "Trent University",
      degree: "Master of Science - MS",
      field: "Big Data Analytics",
      duration: "Jan 2023 - Apr 2024",
      location: "Peterborough, Ontario, Canada",
      skills: ["AWS Lambda", "R Programming", "Python", "Machine Learning", "Data Visualization"]
    },
    {
      id: 2,
      institution: "National University of Computer and Emerging Sciences",
      degree: "Bachelor of Science - BS",
      field: "Computer Science",
      duration: "Aug 2015 - Dec 2019",
      location: "Pakistan",
      skills: ["Artificial Intelligence", "Mobile Development", "Algorithms", "Data Structures"]
    }
  ],
  
  skills: {
    languages: ["Java", "JavaScript", "TypeScript", "Python", "R", "SQL"],
    frameworks: ["Spring Boot", "Angular", "React", "Node.js", "Express"],
    tools: ["Git", "Docker", "Kubernetes", "Jenkins", "Bitbucket", "AWS"],
    databases: ["MongoDB", "PostgreSQL", "MySQL", "NoSQL"],
    other: ["Microservices", "REST APIs", "AWS Lambda", "CI/CD", "Agile", "TDD"]
  },
  
  projects: [
    {
      id: 1,
      title: "Legacy System Migration",
      description: "Migrated multiple legacy Struts applications to modern Spring Boot and Angular stack, improving performance by 60% and reducing technical debt.",
      technologies: ["Spring Boot", "Angular", "AWS", "Docker"],
      highlights: ["40% reduction in deployment time", "85% test coverage achieved", "Microservices architecture implementation"]
    },
    {
      id: 2,
      title: "Enterprise Web Application",
      description: "Developed scalable full-stack web application with microservices architecture, serving thousands of users with high availability.",
      technologies: ["Java", "Spring Boot", "Angular", "PostgreSQL", "Redis"],
      highlights: ["99.9% uptime", "Handles 10k+ concurrent users", "RESTful API design"]
    },
    {
      id: 3,
      title: "Dental Clinic Data Analysis",
      description: "Conducted comprehensive data analysis for a dental clinic, cleaning and analyzing large datasets to extract meaningful insights and improve operational efficiency.",
      technologies: ["Python", "R", "SQL", "Data Cleaning"],
      highlights: ["Large-scale data cleaning", "Complex query optimization", "Actionable insights generation"]
    }
  ],
  
  blogs: [
    {
      id: 1,
      title: "Migrating from Struts to Spring Boot: Lessons Learned",
      excerpt: "A comprehensive guide on modernizing legacy Java applications, covering challenges, best practices, and performance improvements.",
      date: "Dec 15, 2024",
      readTime: "8 min read",
      category: "Software Engineering",
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&h=400&fit=crop"
    },
    {
      id: 2,
      title: "Microservices Architecture: From Monolith to Scalability",
      excerpt: "Exploring the journey of breaking down monolithic applications into microservices, including architecture patterns and deployment strategies.",
      date: "Nov 28, 2024",
      readTime: "10 min read",
      category: "Architecture",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=400&fit=crop"
    },
    {
      id: 3,
      title: "Test-Driven Development: Achieving 85% Code Coverage",
      excerpt: "How I led the initiative to improve test coverage from 20% to 85% using JUnit and best practices in automated testing.",
      date: "Nov 10, 2024",
      readTime: "6 min read",
      category: "Testing",
      image: "https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=800&h=400&fit=crop"
    },
    {
      id: 4,
      title: "AWS Deployment Strategies for Java Applications",
      excerpt: "Practical insights on deploying Spring Boot applications to AWS, reducing deployment time by 40% through automation and CI/CD.",
      date: "Oct 22, 2024",
      readTime: "7 min read",
      category: "DevOps",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=400&fit=crop"
    },
    {
      id: 5,
      title: "Angular Performance Optimization Techniques",
      excerpt: "Deep dive into optimizing Angular applications for better performance, covering lazy loading, change detection, and bundle optimization.",
      date: "Oct 5, 2024",
      readTime: "9 min read",
      category: "Frontend",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop"
    },
    {
      id: 6,
      title: "Transitioning to Canada: A Software Engineer's Journey",
      excerpt: "My experience moving to Canada, navigating the job market, and adapting to the Canadian tech industry as an international professional.",
      date: "Sep 18, 2024",
      readTime: "5 min read",
      category: "Career",
      image: "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=800&h=400&fit=crop"
    }
  ],
  
  testimonial: {
    name: "Ahsin Siddique",
    title: "Founder @Elysian Software Technologies",
    content: "Araiz is a versatile software engineer with expertise in both frontend and backend development. He has a strong problem-solving mindset and is always eager to take on new challenges. Araiz is a great team player and has excellent communication skills, making him an asset to any project. I have had the pleasure of working with him on a complex web application, and his technical skills and dedication were instrumental in its success.",
    relation: "Direct Manager"
  }
};